import { useEffect } from 'react';

/**
 * A reusable window event listener hook
 *
 * Lots of background/guidance here:
 * https://codedaily.io/tutorials/72/Creating-a-Reusable-Window-Event-Listener-Hook-with-useEffect-and-useCallback
 *
 * @param event: The addEventListener eventType, e.g. message
 * @param callback: The callback function. Make sure to use `useCallback`.
 */
export const useWindowEvent = (event: string, callback: any) => {
  useEffect(() => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }, [event, callback]);
};
